import FavouritesDashboardActionTypes from './favouritesDashboard-types'

const INITIAL_STATE = {
    selections: [],
    openSectionsNav: false,
    allFavourites: [],
    clearSelections: false,
}

const toastReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FavouritesDashboardActionTypes.ADD_SELECTION:
            return {
                ...state,
                selections: [...state.selections, action.payload],
                openSectionsNav: true,
            }

        case FavouritesDashboardActionTypes.REMOVE_SELECTION:
            return {
                ...state,
                selections: state.selections.filter(item => item !== action.payload),
            }

        case FavouritesDashboardActionTypes.CLEAR_SELECTED_ASSETS:
            return {
                ...state,
                selections: [],
            }

        case FavouritesDashboardActionTypes.CLOSE_SECTIONS_SIDE_NAV:
            return {
                ...state,
                openSectionsNav: false,
            }

        case FavouritesDashboardActionTypes.SUCCESS_FETCH_ALL_FAVOURITES:
            return {
                ...state,
                allFavourites: [...state.allFavourites, ...action.payload],
            }

        case FavouritesDashboardActionTypes.ADD_ASSET_TO_FAVOURITES:
            return {
                ...state,
                allFavourites: [...state.allFavourites, ...action.payload.map(value => ({ identifier: value }))],
            }

        case FavouritesDashboardActionTypes.REMOVE_ASSET_FROM_FAVOURITES:
            return {
                ...state,
                allFavourites: state.allFavourites.filter(item => item.identifier !== action.payload),
            }

        case FavouritesDashboardActionTypes.REMOVE_MULTIPLE_ASSETS_FROM_FAVOURITES:
            return {
                ...state,
                allFavourites: state.allFavourites.filter(({ identifier }) => !action.payload.some(deletedItem => identifier === deletedItem)),
            }

        default:
            return state
    }
}

export default toastReducer
